import type { UnknownAction } from '@reduxjs/toolkit';

import { resourceStoreTypes, resourceUpserters } from '../core';
import type { QcsSyncResourceStore } from '../core/resourceStoreTypes';
import * as tickerLogosActions from './tickerLogosActions';
import * as tickerLogosTypes from './tickerLogosTypes';

export const QcsSyncTagsStoreFactory =
  resourceStoreTypes.createTypedQcsSyncResourceStoreFactory<tickerLogosTypes.TickerLogoProps>({
    resourceName: 'LOGOS',
  });

function tickerLogosReducer(
  state: QcsSyncResourceStore<tickerLogosTypes.TickerLogoProps> = QcsSyncTagsStoreFactory(),
  action: UnknownAction,
): typeof state {
  switch (true) {
    case tickerLogosActions.getTickerLogosSelected.match(action):
    case tickerLogosActions.getTickerLogosUpdates.match(action):
      return state.set('isLoading', true);
    case tickerLogosActions.getTickerLogosSelectedSuccess.match(action):
      return resourceUpserters.upsertResources(state, {
        resources: (action.payload.data?.resources || []).map((resource: tickerLogosTypes.TickerLogoProps) =>
          tickerLogosTypes.mkTickerLogo(resource),
        ),
      });
    case tickerLogosActions.getTickerLogosUpdatesSuccess.match(action): {
      // TODO: garbage collection of unsued logos
      return resourceUpserters.upsertResources(state, {
        resources: (action.payload.data?.resources || []).map((resource: tickerLogosTypes.TickerLogoProps) =>
          tickerLogosTypes.mkTickerLogo(resource),
        ),
        ...(action.payload.data.metaData?.asOf && { lastSyncDate: action.payload.data.metaData?.asOf }),
      });
    }
    case tickerLogosActions.getTickerLogosSelectedFailure.match(action):
    case tickerLogosActions.getTickerLogosUpdatesFailure.match(action):
      return resourceUpserters.completeWithError(state, action.payload);
    default:
      return state;
  }
}

export default tickerLogosReducer;
